import {createSelector} from 'reselect';
import {getItemsArray} from 'redux/hor/module/selectors';

export const getClientMainRequestsSelector = createSelector(
  state => state.requestsMain,
  getItemsArray
);